import { TrackableType } from "@redotech/redo-order-tracking-trackable-common/trackable";
import * as z from "zod";

const BaseResendEmailInputSchema = z.object({
  emailURL: z.string(),
  templateId: z.string().nullish(),
  /** Sends to this address instead of the customer's email. */
  toEmail: z.string().email().optional(),
});

const ResendFulfillmentGroupEmailInputSchema =
  BaseResendEmailInputSchema.extend({
    fulfillmentGroupId: z.string(),
    trackableType: z.literal(TrackableType.FULFILLMENT_GROUP),
  });

const ResendOrderEmailInputSchema = BaseResendEmailInputSchema.extend({
  orderId: z.string(),
  trackableType: z.literal(TrackableType.ORDER),
});

const ResendReturnEmailInputSchema = BaseResendEmailInputSchema.extend({
  returnId: z.string(),
  trackableType: z.literal(TrackableType.RETURN),
});

export const ResendEmailInputSchema = z.union([
  ResendFulfillmentGroupEmailInputSchema,
  ResendOrderEmailInputSchema,
  ResendReturnEmailInputSchema,
]);

export type ResendEmailInput = z.infer<typeof ResendEmailInputSchema>;

export const resendEmail = {
  name: "resendEmail" as const,
  input: ResendEmailInputSchema,
  output: z.literal("success"),
};
